import { mangataTypesBundleForPolkadotApps } from '@mangata-finance/type-definitions';
import { combineLatest, map } from 'rxjs';
import { memo } from '@polkadot/api-derive/util';
import { TypeRegistry, U128 } from '@polkadot/types';
import { BN } from '@polkadot/util';
function balanceOf(number) {
    return new U128(new TypeRegistry(), number);
}
function defaultAccountBalance() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return {
        accountNonce: new BN(1),
        additional: [],
        availableBalance: balanceOf(0),
        freeBalance: balanceOf(0),
        lockedBalance: balanceOf(0),
        lockedBreakdown: [],
        namedReserves: [],
        reservedBalance: balanceOf(0),
        vestingLocked: balanceOf(0)
    };
}
export function getBalance(instanceId, api) {
    return memo(instanceId, (account) => combineLatest([api.query.tokens.accounts(account, 0), api.query.system.account(account)]).pipe(map(([data, systemAccount]) => {
        return {
            ...defaultAccountBalance(),
            accountId: api.registry.createType('AccountId', account),
            accountNonce: systemAccount.nonce,
            availableBalance: api.registry.createType('Balance', data.free.sub(data.frozen)),
            freeBalance: data.free,
            lockedBalance: data.frozen,
            reservedBalance: data.reserved
        };
    })));
}
const definitions = {
    derives: {
        balances: {
            account: getBalance,
            all: getBalance
        }
    },
    ...mangataTypesBundleForPolkadotApps
};
export default definitions;
